messagePopper = {};

messagePopper.create = function(json) {
    messagePopper.timerID = undefined;
    return new PIXI.Container();

};

messagePopper.showGraphic = function(fileName, callback) {
    messagePopper.isText = false;
    messagePopper.popGraphic = resourceManager.createObject("sprite", "popGraphic", messagePopper.container.name, { anchor: 0.5, fileName: fileName});
    messagePopper.container.visible = true;
    messagePopper.callback = callback;
    messagePopper.timerID = timerManager.addTimer(1300, messagePopper.showMessageProgress, messagePopper.showMessageComplete);
};

messagePopper.showMessage = function(translationPhrase, callback) {
    if (checkForDefined(messagePopper.timerID)) {
        timerManager.stop(messagePopper.timerID);
    }

    messagePopper.isText = true;

    messagePopper.popText.alpha = 1;
    messagePopper.popText.scale.set(1);

    messagePopper.callback = callback;
    messagePopper.container.visible = true;

    messagePopper.popText.setTranslationPhrase(translationPhrase);
    messagePopper.timerID = timerManager.addTimer(1300, messagePopper.showMessageProgress, messagePopper.showMessageComplete);
};

messagePopper.showMessageProgress = function(progress) {
    var popObject = messagePopper.isText ? messagePopper.popText : messagePopper.popGraphic;
    if (progress > 0.5) {
        popObject.alpha = 2 - progress * 2;
    }

    if (messagePopper.isText) {
        popObject.scale.set(1 + progress * 2);
    }
    else {
        popObject.scale.set(0.5 + progress);
    }
};

messagePopper.showMessageComplete = function() {
    messagePopper.popText.alpha = 1;
    messagePopper.popText.scale.set(1);
    messagePopper.container.visible = false;

    if (!messagePopper.isText) {
        resourceManager.destroyObject(messagePopper.popGraphic.name);
    }

    if (messagePopper.callback) {
        messagePopper.callback();
    }
};

messagePopper.initialise = function(json, container, resources) {
    messagePopper.container = container;
    messagePopper.container.visible = false;

    if (checkForUndefined(json.fontDefinition)) {
        console.error("No font specified in message popper");
        json.fontDefinition = "standard";
    }

    messagePopper.popText = resourceManager.createObject("text", "popText", container.name, {fontDefinition: json.fontDefinition, translationPhrase: "", anchor: 0.5});
};

messagePopper.getFilesRequired = function(json) {
    return [];
};

resourceManager.registerObjectType("messagePopper", messagePopper.create, messagePopper.initialise, messagePopper.getFilesRequired);